import ejs from "refractor/ejs";
export default ejs;